import React, { useEffect, useState } from "react";
import graph from "./graph";
import schema from "./schema";
import uiSchema from "./uiSchema";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { isEmptyObject } from "helpers/formatObject";
import { useLazyQuery, useMutation } from "@apollo/client";
import { CircularProgress, Stack, Button, Typography } from "@mui/material";

import {
  NewDialog,
  MuiFormBuilder,
  NewDialogTitle,
  NewDialogContent,
  NewDialogActions,
} from "components";

export default function Update({ id, refetch, title = "ویرایش" }) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const { userToken } = useSelector((state) => state.auth);
  const [fetchModel, { loading }] = useLazyQuery(graph.get.query);
  const [updateModel, { loading: updating }] = useMutation(graph.update.query);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const getModel = async () => {
    try {
      const { data } = await fetchModel({
        context: {
          serviceName: graph.get.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          ids: id,
        },
      });
      if (!isEmptyObject(data)) {
        const res = data[graph.get.name].data[0];
        const { title, details } = res;
        if (res) {
          setFormData({
            title,
            details,
          });
        }
      }
    } catch (error) {}
  };

  const onSubmit = async ({ formData }) => {
    try {
      const { data, errors } = await updateModel({
        context: {
          serviceName: graph.update.serviceName,
          headers: {
            authorization: `Bearer ${userToken}`,
          },
        },
        variables: {
          ids: id,
          ...formData,
        },
      });
      if (!errors) {
        refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.update.name]?.messages.map((message) =>
            toast.success(String(message))
          );
        }
      }
    } catch (error) {
      setFormData(formData);
    }
  };

  useEffect(() => {
    open && getModel();
  }, [open]);

  return (
    <>
      <Button size="small" color="info" variant="outlined" onClick={onOpen}>
        ویرایش
      </Button>
      <NewDialog open={open} onClose={onClose}>
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack p={1} flex={1} rowGap={1} bgcolor="background.paper">
            {loading ? (
              <Stack
                rowGap={2}
                height="100%"
                alignItems="center"
                justifyContent="center"
              >
                <CircularProgress size={20} color="inherit" />
                <Typography
                  align="center"
                  variant="caption"
                  color="text.disabled"
                >
                  در حال بارگذاری...
                </Typography>
              </Stack>
            ) : (
              <MuiFormBuilder
                id="submit"
                showSubmit={false}
                liveValidate={false}
                schema={schema()}
                uiSchema={uiSchema()}
                formData={formData}
                onSubmit={onSubmit}
              />
            )}
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button
            autoFocus
            fullWidth
            size="large"
            type="submit"
            form="submit"
            variant="contained"
            disabled={loading || updating}
          >
            ویرایش
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
